import React, { useState } from "react";
import "./landingPage.scss";
import Hero from "../../components/landing/Hero/Hero";
import HowItWorks from "../../components/landing/HowItWorks/HowItWorks";
import StartProject from "../../components/landing/StartProject/StartProject";
import FAQ from "../../components/landing/FAQ/FAQ";
import Contact from "../../components/landing/Contact/Contact";
import Footer from "../../components/common/Footer/Footer";

const LandingPage = () => {
    const [showQuoteFlow, setShowQuoteFlow] = useState(false);
    const [userEmail, setUserEmail] = useState("");

    const handleEmailSubmit = (email) => {
        setUserEmail(email);
        setShowQuoteFlow(true);
    };

    return (
        <div className="landing-page">
            {!showQuoteFlow ? (
                <>
                    <Hero />
                    <HowItWorks />
                    <StartProject onEmailSubmit={handleEmailSubmit} />
                    <FAQ />
                    <Contact />
                    <Footer />
                </>
            ) : (
                <div className="quote-flow-container">
                    <p>Flujo de cotización para: {userEmail}</p>
                </div>
            )}
        </div>
    );
};

export default LandingPage;
